<div class="bg-white border-bottom">
    <div class="px-5">
        <header
            class="d-flex flex-wrap align-items-center justify-content-between py-3">
            <div class="col-md-3 mb-2 mb-md-0">
                <a href="/" class="d-inline-flex link-body-emphasis text-decoration-none">
                    <img [src]="logoUrl || '/assets/img/logo-black.svg'" [alt]="logoAlt" />
                </a>
            </div>

            <div class="col-md-9 text-right">
                <ng-content></ng-content>
            </div>
        </header>
    </div>
</div>